import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {IMailLogModel} from './MailLogModel'
import {IMailTemplateModel, IMailTemplateParam} from './MailTemplateModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const MAIL_TEMPLATE_URL = `${API_URL}api/v1/mail-template/`

export function loadMailTemplates(
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<IMailTemplateModel>>>> {
  return corporateApi.get(`${MAIL_TEMPLATE_URL}getAll`, {params: {page, size}})
}

export function createMailTemplate(
  template: IMailTemplateModel
): Promise<AxiosResponse<ApiResponse<IMailTemplateModel>>> {
  return corporateApi.post(`${MAIL_TEMPLATE_URL}create`, template)
}

export function updateMailTemplate(
  template: IMailTemplateModel
): Promise<AxiosResponse<ApiResponse<IMailTemplateModel>>> {
  return corporateApi.patch(`${MAIL_TEMPLATE_URL}update/${template.id}`, template)
}

export function deleteMailTemplate(templateId: string) {
  return corporateApi.delete(`${MAIL_TEMPLATE_URL}delete/${templateId}`)
}

/** Şablonlarda kullanılabilen parametreler; tek kaynak backend enum'u */
export function loadMailTemplateParams(): Promise<AxiosResponse<ApiResponse<IMailTemplateParam[]>>> {
  return corporateApi.get(`${MAIL_TEMPLATE_URL}parameters`)
}

/** Bir başvuruya gönderilen otomatik mailler */
export function loadMailLogs(
  applyJobId: string
): Promise<AxiosResponse<ApiResponse<IMailLogModel[]>>> {
  return corporateApi.get(`${MAIL_TEMPLATE_URL}log/getByApplyJobId/${applyJobId}`)
}
